export default {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	data() {
		return {
			months: [
				{name: "Jan", fullName: "January", ordinal: 1},
				{name: "Feb", fullName: "February", ordinal: 2},
				{name: "Mar", fullName: "March", ordinal: 3},
				{name: "Apr", fullName: "April", ordinal: 4},
				{name: "May", fullName: "May", ordinal: 5},
				{name: "Jun", fullName: "June", ordinal: 6},
				{name: "Jul", fullName: "July", ordinal: 7},
				{name: "Aug", fullName: "August", ordinal: 8},
				{name: "Sep", fullName: "September", ordinal: 9},
				{name: "Oct", fullName: "October", ordinal: 10},
				{name: "Nov", fullName: "November", ordinal: 11},
				{name: "Dec", fullName: "December", ordinal: 12},
			],
		}
	},
	methods: {
		formatToDate(dateTime: any) {
			if (!(dateTime instanceof Date)) {
				dateTime = new Date(dateTime);
			}
			const formatted = new Intl.DateTimeFormat("en", {year: 'numeric', month: '2-digit', day: '2-digit'}).formatToParts(dateTime);
			return formatted[4].value + "-" + formatted[0].value + "-" + formatted[2].value;
		},
		formatToDateShortMonth(dateTime: any){
			if (!(dateTime instanceof Date)) {
				dateTime = new Date(dateTime);
			}
			const formatted = new Intl.DateTimeFormat("en", {year: 'numeric', month: 'short', day: '2-digit'}).formatToParts(dateTime);
			return formatted[2].value + " " + formatted[0].value + " " + formatted[4].value;
		},
		formatToDateTime(dateTime: any) {
			if (!(dateTime instanceof Date)) {
				dateTime = new Date(dateTime);
			}
			const formatted = new Intl.DateTimeFormat("en", {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false}).formatToParts(dateTime);
			return formatted[4].value + "-" + formatted[0].value + "-" + formatted[2].value + " " + formatted[6].value + ":" + formatted[8].value + ":" + formatted[10].value;
		},
		formatToDateTimeUTC(dateTime: any) {
			if (!(dateTime instanceof Date)) {
				dateTime = new Date(dateTime);
			}
			const formatted = new Intl.DateTimeFormat("en", {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false, timeZone: 'UTC'}).formatToParts(dateTime);
			return formatted[4].value + "-" + formatted[0].value + "-" + formatted[2].value + " " + formatted[6].value + ":" + formatted[8].value + ":" + formatted[10].value;
		},
		formatToSimpleDateTime(dateTime: any) {
			if (!(dateTime instanceof Date)) {
				dateTime = new Date(dateTime);
			}
			const formatted = new Intl.DateTimeFormat("en", {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false}).formatToParts(dateTime);
			return formatted[4].value + formatted[0].value + formatted[2].value + formatted[6].value + formatted[8].value + formatted[10].value;
		},
		formatToTime24Hour(dateTime: any) {
			if (!(dateTime instanceof Date)) {
				dateTime = new Date(dateTime);
			}
			const formatted = new Intl.DateTimeFormat("en", {hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false}).formatToParts(dateTime);
			return formatted[0].value + ":" + formatted[2].value;
		},
		formatToCardDate(dateTime: any) {
            if (!(dateTime instanceof Date)) {
				dateTime = new Date(dateTime);
			}
			const formatted = new Intl.DateTimeFormat("en", {weekday: 'short', day: '2-digit', month: 'short'}).formatToParts(dateTime);
            return formatted[4].value + " " + formatted[2].value + " (" + formatted[0].value + ")";
        },
        formatToReportDateTime(dateTime: any) {
            if (!(dateTime instanceof Date)) {
				dateTime = new Date(dateTime);
			}
			const formatted = new Intl.DateTimeFormat("en", {weekday: 'long', year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true}).formatToParts(dateTime);
			return formatted[0].value + ", " + formatted[2].value + " " + formatted[4].value + ", " + formatted[6].value + " at " + formatted[8].value + ":" + formatted[10].value + " " + formatted[14].value;
        },
        formatToWeekDay(dateTime: any) {
            if (!(dateTime instanceof Date)) {
				dateTime = new Date(dateTime);
			}
			const formatted = new Intl.DateTimeFormat("en", {weekday: 'short'}).formatToParts(dateTime);
            return formatted[0].value;
        },
		formatToDayMonthYear(dateTime: any) {
			if (!(dateTime instanceof Date)) {
				dateTime = new Date(dateTime);
			}
			const formatted = new Intl.DateTimeFormat("en", {year: 'numeric', month: '2-digit', day: '2-digit'}).formatToParts(dateTime);
			return formatted[2].value + "/" + formatted[0].value + "/" + formatted[4].value;
		},
		formatToMonthYear(dateTime: any) {
			if (!(dateTime instanceof Date)) {
				dateTime = new Date(dateTime);
			}
			const formatted = new Intl.DateTimeFormat("en", {year: 'numeric', month: '2-digit', day: '2-digit'}).formatToParts(dateTime);
			return formatted[0].value + "/" + formatted[4].value;
		},
		formatToYear(dateTime: any) {
			if (!(dateTime instanceof Date)) {
				dateTime = new Date(dateTime);
			}
			const formatted = new Intl.DateTimeFormat("en", {year: 'numeric', month: '2-digit', day: '2-digit'}).formatToParts(dateTime);
			return formatted[4].value;
		},
		formatToDayShortMonthYear(dateTime: any) {
			if (!(dateTime instanceof Date)) {
				dateTime = new Date(dateTime);
			}
			const formatted = new Intl.DateTimeFormat("en", {year: 'numeric', month: 'short', day: '2-digit'}).formatToParts(dateTime);
			return formatted[2].value + "/" + formatted[0].value + "/" + formatted[4].value;
		},
		formatToShortMonthYear(dateTime: any) {
			if (!(dateTime instanceof Date)) {
				dateTime = new Date(dateTime);
			}
			const formatted = new Intl.DateTimeFormat("en", {year: 'numeric', month: 'short', day: '2-digit'}).formatToParts(dateTime);
			return formatted[0].value + "/" + formatted[4].value;
		},
        getYearDifferent(date1: any, date2: any) {
			return Math.abs(date2.getFullYear() - date1.getFullYear() + 1);
		},
		getMonthDifferent(date1: any, date2: any) {
			return (date2.getMonth() - date1.getMonth() + 1 + 12 * (date2.getFullYear() - date1.getFullYear()));
		},
		getDayDifferent(date1: any, date2: any) {
			return Math.round((date2 - date1) / (24 * 60 * 60 * 1000)) + 1;
		},
		getStartOfMonth(dateTime: any) {
			dateTime = new Date(dateTime.getFullYear(), dateTime.getMonth(), 1);
			const formatted = new Intl.DateTimeFormat("en", {year: 'numeric', month: '2-digit', day: '2-digit'}).formatToParts(dateTime);
			return formatted[4].value + "-" + formatted[0].value + "-" + formatted[2].value;
		},
		getEndOfMonth(dateTime: any) {
			dateTime = new Date(dateTime.getFullYear(), dateTime.getMonth() + 1, 0);
			const formatted = new Intl.DateTimeFormat("en", {year: 'numeric', month: '2-digit', day: '2-digit'}).formatToParts(dateTime);
			return formatted[4].value + "-" + formatted[0].value + "-" + formatted[2].value;
		},
		/**
		 * Convert Unicode date format to PrimeVue format
		 */
		unicodeToPrimeVue(unicodeFormat: any) {
		if (!unicodeFormat || typeof unicodeFormat !== 'string') {
			return 'dd/mm/yy'; // Default format
		}
		return unicodeFormat
			.replace(/yyyy|yy|MMMM|MMM|MM|M|dddd|ddd|dd|d/g, (match) => {
				switch (match) {
					case 'yyyy': return 'yy'; // 4-digit year
					case 'yy': return 'y';   // 2-digit year
					case 'MMMM': return 'MM'; // Month name long
					case 'MMM': return 'M';  // Month name short
					case 'MM': return 'mm'; // 2-digit month
					case 'M': return 'm'; // 1-digit month
					case 'dddd': return 'DD'; // Day name long
					case 'ddd': return 'D'; // Day name short
					
					default: return match;
				}
			});
		},
		/**
		 * Convert PrimeVue date format to Unicode format
		 */
		primeVueToUnicode(primeVueFormat: any) {
			if (!primeVueFormat || typeof primeVueFormat !== 'string') {
				return 'dd/MM/yyyy'; // Default format
			}
		return primeVueFormat
			.replace(/yy|y|MM|M|mm|m|DD|D|dd|d/g, (match) => {
				switch (match) {
					case 'yy': return 'yyyy'; // 4-digit year
					case 'y': return 'yy';   // 2-digit year
					case 'MM': return 'MMMM'; // Month name long
					case 'M': return 'MMM';  // Month name short
					case 'mm': return 'MM'; // 2-digit month
					case 'm': return 'M'; // 1-digit month
					case 'DD': return 'dddd'; // Day name long
					case 'D': return 'ddd'; // Day name short

					default: return match;
				}
			});
		}
	}
};